import React, { useEffect, useState } from "react";
import "./RequestBalanceContainer.css";
import { Header } from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import RequestBalanceHome from "../../components/RequestBalanceHome/RequestBalanceHome";
import ProcessedRequest from "../../components/ProcessedRequest/ProcessedRequest";
import { getProductsService } from "../../services/productsService";
import { getMsisdnService } from "../../services/getMsisdnService";
import AppContext from "../../AppContext";
import Spinner from "../../components/Spinner";
import {
  HOME_SCREEN,
  COMUNICATION_ERROR_SCREEN,
  MESSAGE_SENT_SCREEN,
  TRIES_ERROR_SCREEN,
  WRONG_NUMBER_SCREEN,
  PRODUCT_200_ID,
  SOURCE,
} from "../../constants/constants";
import Request from "../../services/Request";

const api = new Request();
const RequestBalanceContainer = () => {
  const [spinner, setSpinner] = useState(true);
  const [products, setProducts] = useState([]);
  const [screen, setScreen] = useState(HOME_SCREEN);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [isVisiblePopUpDetails, setIsVisiblePopUpDetails] = useState(null);
  const [msisdn, setMsisdn] = useState("");
  const [offerId, setOfferId] = useState("");
  const [offerAuxId, setOfferAuxId] = useState("");
  const [requestId, setRequestId] = useState("");
  const [errorProduct, setErrorProduct] = useState(null);
  const [errorName, setErrorName] = useState(null);
  const [errorNumber, setErrorNumber] = useState(null);
  const [loading, setLoading] = useState(null);
  const [sessionId, setSessionId] = useState("");
  const [source, setSource] = useState(null);

  const sendMessage = async () => {
    try {
      const numberStatus = await api
        .isUsaNumber(
          number,
          name,
          offerId,
          offerAuxId,
          selectedProduct?.pkgType
        )
        .catch(() => {
          setScreen(COMUNICATION_ERROR_SCREEN);
          return 666;
        });

      if (numberStatus.responseStatus === 709) {
        setLoading(false);
        await api.setTries(number);
        const response = await api.getTries(number);
        const tries = parseInt(response?.responseObject?.attemptCounter);

        if (tries > 2) {
          // exceso de intentos
          setScreen(TRIES_ERROR_SCREEN);
        } else {
          // numero incorrecto
          setScreen(WRONG_NUMBER_SCREEN);
        }
      } else if (numberStatus?.responseStatus === 708) {
        // exceso de intentos
        setScreen(TRIES_ERROR_SCREEN);
      } else if (numberStatus?.responseStatus === 0) {
        // sms enviado
        setScreen(MESSAGE_SENT_SCREEN);
      } else {
        // Error inesperado
        setScreen(COMUNICATION_ERROR_SCREEN);
        await api.setTries(number);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setScreen(COMUNICATION_ERROR_SCREEN);
      await api.setTries(number);
    }
  };

  const getInitialData = async (offerId, msisdn) => {
    try {
      const response = await getMsisdnService(offerId, msisdn);
      setMsisdn(response?.msisdn);
      setOfferId(response?.offerId);
      setOfferAuxId(response?.offerAuxId);
      setRequestId(response?.requestId);
    } catch (error) {
      console.log(error);
    }
    try {
      const products = await getProductsService();
      const newProducts = products.filter(
        (item) =>
          item.pkgType === "PA50" ||
          item.pkgType === "PA100" ||
          item.pkgType === "PA200" ||
          item.pkgType === "PA150"
      );

      setProducts(newProducts);
      setSelectedProduct(products.find(item => item.productId === PRODUCT_200_ID));
      setSpinner(false);
    } catch (error) {
      setProducts([
        {
          productId: 10,
          service: { serviceId: 2, description: "Paquetes" },
          amount: 100,
          title: "Paquete Sin Límite 100",
          subtitle:
            "$100: Vig. 15 días 1.3GB, Redes Sociales y Whatsapp Ilimitados",
          type: "mep.balance",
          clazz: "com.fonyou.vega.mep.dto.lib.dto.MepBalanceProductDTO",
          button: "Seleccionar",
          offerOrder: 2,
          orderBot: 3,
          image: "https://llp.mx/img/bot/v2/sl100.png",
          recommended: false,
          preselected: false,
          category: {
            categoryId: 4,
            description: "Sin Límite",
            order: 1,
            subtitle: "Llamadas, SMS y redes sociales ilimitadas + MB",
            image: "https://llp.mx/img/bot/v2/sl.png",
          },
          pkgType: "PA100",
          pkgValidity: "15 días",
          pkgInternetMb: "1.3 GB",
          pkgMinutesSms: "Ilimitados",
          pkgSocialNetMb: "Ilimitado",
          pkgMessagingMb: "Ilimitado",
          pkgBestSeller: true,
          pkgFb: true,
          pkgFbMsn: true,
          pkgTwitter: true,
          pkgSnapchat: true,
          pkgInstagram: true,
          pkgWhatsapp: true,
          pkgClaroMusic: false,
          promotion: false,
          promotionDesc: null,
        },
        {
          productId: 12,
          service: { serviceId: 2, description: "Paquetes" },
          amount: 200,
          title: "Paquete Sin Límite 200",
          subtitle:
            "$200: Vig. 30 días 3GB + 500MB de Claro Música + Redes y Whatsapp Ilimitados",
          type: "mep.balance",
          clazz: "com.fonyou.vega.mep.dto.lib.dto.MepBalanceProductDTO",
          button: "Seleccionar",
          offerOrder: 4,
          orderBot: 1,
          image: "https://llp.mx/img/bot/v2/sl200.png",
          recommended: false,
          preselected: false,
          category: {
            categoryId: 4,
            description: "Sin Límite",
            order: 1,
            subtitle: "Llamadas, SMS y redes sociales ilimitadas + MB",
            image: "https://llp.mx/img/bot/v2/sl.png",
          },
          pkgType: "PA200",
          pkgValidity: "30 días",
          pkgInternetMb: "3 GB",
          pkgMinutesSms: "Ilimitados",
          pkgSocialNetMb: "Ilimitado",
          pkgMessagingMb: "Ilimitado",
          pkgBestSeller: true,
          pkgFb: true,
          pkgFbMsn: true,
          pkgTwitter: true,
          pkgSnapchat: true,
          pkgInstagram: true,
          pkgWhatsapp: true,
          pkgClaroMusic: true,
          promotion: false,
          promotionDesc: null,
        },
        {
          productId: 8,
          service: { serviceId: 2, description: "Paquetes" },
          amount: 50,
          title: "Paquete Sin Límite 50",
          subtitle:
            "$50: Vig. 7 días 400MB + 750MB Redes Sociales, Whatsapp Ilimitado",
          type: "mep.balance",
          clazz: "com.fonyou.vega.mep.dto.lib.dto.MepBalanceProductDTO",
          button: "Seleccionar",
          offerOrder: 5,
          orderBot: 4,
          image: "https://llp.mx/img/bot/v2/sl50.png",
          recommended: false,
          preselected: false,
          category: {
            categoryId: 4,
            description: "Sin Límite",
            order: 1,
            subtitle: "Llamadas, SMS y redes sociales ilimitadas + MB",
            image: "https://llp.mx/img/bot/v2/sl.png",
          },
          pkgType: "PA50",
          pkgValidity: "7 días",
          pkgInternetMb: "400 MB",
          pkgMinutesSms: "Ilimitados",
          pkgSocialNetMb: "750 MB",
          pkgMessagingMb: "Ilimitado",
          pkgBestSeller: false,
          pkgFb: true,
          pkgFbMsn: true,
          pkgTwitter: true,
          pkgSnapchat: true,
          pkgInstagram: true,
          pkgWhatsapp: true,
          pkgClaroMusic: false,
          promotion: false,
          promotionDesc: null,
        },
      ]);
      setSelectedProduct({
        productId: 10,
        service: { serviceId: 2, description: "Paquetes" },
        amount: 100,
        title: "Paquete Sin Límite 100",
        subtitle:
          "$100: Vig. 15 días 1.3GB, Redes Sociales y Whatsapp Ilimitados",
        type: "mep.balance",
        clazz: "com.fonyou.vega.mep.dto.lib.dto.MepBalanceProductDTO",
        button: "Seleccionar",
        offerOrder: 2,
        orderBot: 3,
        image: "https://llp.mx/img/bot/v2/sl100.png",
        recommended: false,
        preselected: false,
        category: {
          categoryId: 4,
          description: "Sin Límite",
          order: 1,
          subtitle: "Llamadas, SMS y redes sociales ilimitadas + MB",
          image: "https://llp.mx/img/bot/v2/sl.png",
        },
        pkgType: "PA100",
        pkgValidity: "15 días",
        pkgInternetMb: "1.3 GB",
        pkgMinutesSms: "Ilimitados",
        pkgSocialNetMb: "Ilimitado",
        pkgMessagingMb: "Ilimitado",
        pkgBestSeller: true,
        pkgFb: true,
        pkgFbMsn: true,
        pkgTwitter: true,
        pkgSnapchat: true,
        pkgInstagram: true,
        pkgWhatsapp: true,
        pkgClaroMusic: false,
        promotion: false,
        promotionDesc: null,
      });
      setSpinner(false);
    }
  };

  const doCallTracking = (
    elementName,
    elementLocation,
    beneficiaryMsisdn = ""
  ) => {
    api.callTracking(
      elementName,
      elementLocation,
      msisdn,
      offerId,
      requestId,
      beneficiaryMsisdn,
      source ? source : null
    );
  };

  useEffect(() => {
    const params = window.location.pathname.replace(/^\//, "").split("/");
    if (params[1] && params[2]) {
      getInitialData(params[1], params[2]);
    }
  }, []);

  useEffect(() => {
    const params = window.location.pathname.replace(/^\//, "").split("/");
    if (params[1]) {
      setSessionId(params[1]);
    }
  }, []);

  useEffect(()=>{
    const params = window.location.pathname.replace(/^\//, "").split("/");
    
    switch (params[0]) {
      case "solicitamobi":
        setSource("MICROSITE")
        break;
      case "solicitamodal":
        setSource("MICROSITE_MODAL")
        break;
      default:
        setSource(SOURCE)
        break;
    }
  },[])

  if (spinner) {
    return <Spinner />;
  }

  return (
    <AppContext.Provider
      value={{
        products,
        selectedProduct,
        setSelectedProduct,
        number,
        setNumber,
        name,
        setName,
        sendMessage,
        screen,
        setScreen,
        isVisiblePopUpDetails,
        setIsVisiblePopUpDetails,
        doCallTracking,
        errorProduct,
        setErrorProduct,
        errorName,
        setErrorName,
        errorNumber,
        setErrorNumber,
        loading,
        setLoading,
        offerAuxId,
        offerId,
        sessionId,
        msisdn,
      }}
    >
      {isVisiblePopUpDetails && (
        <div className="request__balance__container__shadow" />
      )}
      <div
        className={`request__balance__container ${
          isVisiblePopUpDetails && "activated__popup"
        }`}
      >
        <Header msisdn={msisdn} />
        <div className="header__rectangle" />
        <div className="figure__elipse" />
        {screen === HOME_SCREEN ? <RequestBalanceHome /> : <ProcessedRequest />}

        {screen === HOME_SCREEN && <Footer />}
      </div>
    </AppContext.Provider>
  );
};

export default RequestBalanceContainer;
